import { render, staticRenderFns } from "./statistics-chart-visits.vue?vue&type=template&id=36493f9f&scoped=true"
import script from "./statistics-chart-visits.vue?vue&type=script&lang=js"
export * from "./statistics-chart-visits.vue?vue&type=script&lang=js"
import style0 from "./statistics-chart-visits.vue?vue&type=style&index=0&id=36493f9f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36493f9f",
  null
  
)

export default component.exports